import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function StripesAnimation() {
    document.addEventListener('DOMContentLoaded', () => {
        const elements = document.querySelectorAll('[data-stripes-animation]');
        if (!elements.length) return;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        const BASE_X = -50;

        elements.forEach((el) => {
            // Sticky-section ma własny timeline — sterowanie paskami przejmuje StickySection.js,
            // żeby paski jechały synchronicznie z całą animacją sekcji (nie kończyły się
            // przedwcześnie zanim user zescrolluje całość)
            if (el.closest('[data-sticky-section]')) return;

            const image = el.querySelector('img');
            if (!image) return;

            // ile % szerokości obrazka przesuwamy od pozycji wycentrowanej (-50%);
            // przy obrazku 352rem i kontenerze (--wrapper-width 134.4rem) overflow na bok
            // to ~108.9rem → bezpieczny limit to ~30% (dalej widać brzeg obrazka)
            const distance = parseFloat(el.dataset.stripesAnimation) || 20;

            // x: 0 zeruje px, które GSAP wylicza z CSS-owego translateX(-50%) i dokłada do xPercent
            // (stąd dublujący się transform: translate(...%) translate(-1636px)). Centruje sam xPercent.
            gsap.fromTo(
                image,
                { x: 0, xPercent: BASE_X }, // start: wycentrowany (-50%), gdy sekcja wchodzi w viewport
                {
                    x: 0,
                    xPercent: BASE_X + distance, // koniec: przesunięty o `distance`, gdy sekcja wychodzi
                    ease: 'none',
                    scrollTrigger: {
                        trigger: el,
                        start: 'top bottom', // sekcja zaczyna być widoczna (góra przy dole ekranu)
                        end: 'bottom top', // sekcja znika (dół przy górze ekranu)
                        scrub: true, // progress = przescrollowanie sekcji w widoku
                    },
                },
            );
        });
    });
}
